var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongBiaoqing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tongyong_biaoqing_svg__clip0_5124_53741)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.5,
    stroke: "#3F465C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.465 9a3.5 3.5 0 01-6.93 0h6.93z",
    stroke: "#3F465C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 6,
    r: 1,
    fill: "#3F465C"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 6,
    r: 1,
    fill: "#3F465C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tongyong_biaoqing_svg__clip0_5124_53741"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/tongyong_biaoqing.d06875ca.svg";
export { SvgTongyongBiaoqing as ReactComponent };